module.exports = __webpack_public_path__ + "assets/img/0417e149b7ec8eeb0da837b6fdf571b0.png";